import gql from 'graphql-tag';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  Time: { input: any; output: any; }
};

export enum DisplayLocation {
  Checkout = 'CHECKOUT',
  LandingPage = 'LANDING_PAGE'
}

export type PaginatorResponse = {
  totalEntries: Scalars['Int']['output'];
};

export type Query = {
  __typename?: 'Query';
  articleIndex?: Maybe<StrapiArticlesIndex>;
  articles: Array<StrapiArticle>;
  contentPages: Array<StrapiContentPage>;
  discounts: Array<StrapiDiscount>;
  event?: Maybe<StrapiEvent>;
  gameserver?: Maybe<StrapiGameserverIndex>;
  homePage?: Maybe<StrapiHomePage>;
  locales: Array<Scalars['String']['output']>;
  modpacks: StrapiMinecraftModpackResult;
  productGroups: Array<StrapiProductGroup>;
  product_countdown?: Maybe<StrapiProductCountdown>;
  product_top_bar: Array<StrapiTopBarFeature>;
  products: Array<StrapiProduct>;
  reviewScore?: Maybe<TrustPilotScore>;
  sustainabilityPage?: Maybe<StrapiSustainabilityPage>;
};


export type QueryArticleIndexArgs = {
  locale: Scalars['String']['input'];
};


export type QueryArticlesArgs = {
  articleKey?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  category?: InputMaybe<StrapiArticleCategory>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  search?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  type?: InputMaybe<StrapiArticleType>;
};


export type QueryContentPagesArgs = {
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_match?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryGameserverArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  locale: Scalars['String']['input'];
};


export type QueryHomePageArgs = {
  locale: Scalars['String']['input'];
};


export type QueryModpacksArgs = {
  currency?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale: Scalars['String']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  region: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  tags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QueryProductGroupsArgs = {
  locale: Scalars['String']['input'];
};


export type QueryProduct_CountdownArgs = {
  locale: Scalars['String']['input'];
};


export type QueryProduct_Top_BarArgs = {
  locale: Scalars['String']['input'];
};


export type QueryProductsArgs = {
  chargebeePlanId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  currency?: InputMaybe<Scalars['String']['input']>;
  displayLocation?: InputMaybe<DisplayLocation>;
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  id?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  platform?: InputMaybe<Array<InputMaybe<StrapiPlatform>>>;
  productKey?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  product_type?: InputMaybe<Array<InputMaybe<StrapiProductType>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  slug_match?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type QuerySustainabilityPageArgs = {
  locale: Scalars['String']['input'];
};

export type StrapiArticle = {
  __typename?: 'StrapiArticle';
  articleKey: Scalars['String']['output'];
  category: StrapiArticleCategory;
  content: Array<StrapiContent>;
  createdAt: Scalars['Time']['output'];
  firstPublishedAt?: Maybe<Scalars['Time']['output']>;
  footerButtons: Array<StrapiButton>;
  headerCoverImage: StrapiImage;
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  localizedSlugs: Array<StrapiLocalizedSlug>;
  metaDescription?: Maybe<Scalars['String']['output']>;
  metaTitle: Scalars['String']['output'];
  product?: Maybe<StrapiProduct>;
  publishedAt?: Maybe<Scalars['Time']['output']>;
  slug: Scalars['String']['output'];
  teaserImage?: Maybe<StrapiImage>;
  teaserText: Scalars['String']['output'];
  thumbnailImage: StrapiImage;
  title: Scalars['String']['output'];
  type: StrapiArticleType;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export enum StrapiArticleCategory {
  Action = 'Action',
  Event = 'Event',
  NewGame = 'NewGame',
  None = 'None'
}

export enum StrapiArticleType {
  Blog = 'Blog',
  News = 'News'
}

export type StrapiArticlesIndex = {
  __typename?: 'StrapiArticlesIndex';
  createdAt: Scalars['Time']['output'];
  headerCoverImage?: Maybe<StrapiImage>;
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  localizedSlugs: Array<StrapiLocalizedSlug>;
  metaDescription: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['Time']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type StrapiBanner = StrapiContent & {
  __typename?: 'StrapiBanner';
  backgroundImage: StrapiImage;
  buttons?: Maybe<Array<StrapiButton>>;
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  promoText?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type StrapiBenefit = StrapiContent & {
  __typename?: 'StrapiBenefit';
  benefits: Array<StrapiBenefitContent>;
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type StrapiBenefitContent = {
  __typename?: 'StrapiBenefitContent';
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  icon?: Maybe<StrapiImage>;
  id: Scalars['ID']['output'];
  isDefault: Scalars['Boolean']['output'];
  locale: Scalars['String']['output'];
  privateTitle: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['Time']['output']>;
  sort: Scalars['Int']['output'];
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type StrapiBenefitList = {
  __typename?: 'StrapiBenefitList';
  benefits: Array<StrapiBenefitContent>;
  title: Scalars['String']['output'];
};

export type StrapiBlockbuster = {
  __typename?: 'StrapiBlockbuster';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  items: Array<StrapiBlockbusterItem>;
  locale: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['Time']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type StrapiBlockbusterItem = {
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type StrapiBlockbusterItemComponent = StrapiBlockbusterItem & {
  __typename?: 'StrapiBlockbusterItemComponent';
  backgroundImage: StrapiImage;
  buttons: Array<StrapiButton>;
  component: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  text: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type StrapiButton = StrapiContent & {
  __typename?: 'StrapiButton';
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<StrapiImage>;
  link: Scalars['String']['output'];
  newTab: Scalars['Boolean']['output'];
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type StrapiContent = {
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type StrapiContentPage = {
  __typename?: 'StrapiContentPage';
  backgroundImage?: Maybe<StrapiImage>;
  content: Array<StrapiContent>;
  coverImage: StrapiImage;
  createdAt: Scalars['Time']['output'];
  headerCoverImage?: Maybe<StrapiImage>;
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  localizedSlugs: Array<StrapiLocalizedSlug>;
  metaDescription: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['Time']['output']>;
  releaseAt?: Maybe<Scalars['Time']['output']>;
  slug: Scalars['String']['output'];
  subHeadline: Scalars['String']['output'];
  title: Scalars['String']['output'];
  topBarFeature?: Maybe<StrapiTopBarFeature>;
  topCoverImage?: Maybe<StrapiImage>;
  updatedAt: Scalars['Time']['output'];
};

export type StrapiCountdownComponent = {
  __typename?: 'StrapiCountdownComponent';
  endDate: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type StrapiCustomComponent = StrapiContent & {
  __typename?: 'StrapiCustomComponent';
  component: Scalars['String']['output'];
  customComponent: StrapiCustomComponentContent;
  id: Scalars['ID']['output'];
};

export type StrapiCustomComponentContent = {
  __typename?: 'StrapiCustomComponentContent';
  backgroundImage?: Maybe<StrapiImage>;
  buttons?: Maybe<Array<StrapiButton>>;
  componentKey: Scalars['String']['output'];
  content?: Maybe<Scalars['String']['output']>;
  displayLocation: DisplayLocation;
  id: Scalars['ID']['output'];
  layoutImages?: Maybe<Array<StrapiLayoutImage>>;
  locale: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type StrapiDiscount = {
  __typename?: 'StrapiDiscount';
  applyToAll: Scalars['Boolean']['output'];
  couponCode?: Maybe<Scalars['String']['output']>;
  discountKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  percent: Scalars['Float']['output'];
  products?: Maybe<Array<StrapiProduct>>;
  validFrom: Scalars['Time']['output'];
  validUntil: Scalars['Time']['output'];
};

export type StrapiEvent = {
  __typename?: 'StrapiEvent';
  articleHeaderCoverImageOverlay?: Maybe<StrapiImage>;
  articleThumbnailImagesOverlay?: Maybe<Array<StrapiImage>>;
  datetimeEnd: Scalars['Time']['output'];
  datetimeStart: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  orderConfigurationsBackground?: Maybe<Array<StrapiImage>>;
  productCoverImageOverlay?: Maybe<StrapiImage>;
  productHeaderCoverImageOverlay?: Maybe<StrapiImage>;
  productTopCoverImageOverlay?: Maybe<StrapiImage>;
  reflink?: Maybe<Scalars['String']['output']>;
};

export type StrapiFaqEntry = {
  __typename?: 'StrapiFAQEntry';
  content: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  icon?: Maybe<StrapiImage>;
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['Time']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type StrapiFaqList = {
  __typename?: 'StrapiFaqList';
  backgroundImage: StrapiImage;
  frequentlyAskedQuestions: Array<StrapiFaqEntry>;
  title: Scalars['String']['output'];
};

export type StrapiGameserverIndex = {
  __typename?: 'StrapiGameserverIndex';
  benefits: StrapiBenefitList;
  countdown?: Maybe<StrapiCountdownComponent>;
  createdAt: Scalars['Time']['output'];
  description: Scalars['String']['output'];
  faq: StrapiFaqList;
  headline: Scalars['String']['output'];
  id: Scalars['Int']['output'];
  locale: Scalars['String']['output'];
  localizedSlugs: Array<StrapiLocalizedSlug>;
  metaDescription: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['Time']['output']>;
  topSeller?: Maybe<StrapiProduct>;
  trustpilot?: Maybe<StrapiTrustpilot>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type StrapiHomePage = {
  __typename?: 'StrapiHomePage';
  blockbuster: StrapiBlockbuster;
  content: Array<StrapiContent>;
  countdown?: Maybe<StrapiCountdownComponent>;
  createdAt: Scalars['Time']['output'];
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  localizedSlugs: Array<StrapiLocalizedSlug>;
  metaDescription: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  partnersGallery?: Maybe<StrapiHomePagePartnersGalleryComponent>;
  publishedAt?: Maybe<Scalars['Time']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type StrapiHomePageGalleryBannerComponent = StrapiContent & StrapiHomePageMetaInfoComponent & {
  __typename?: 'StrapiHomePageGalleryBannerComponent';
  buttons: Array<StrapiButton>;
  component: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  mediaGallery: StrapiMediaGallery;
  teaserText: Scalars['String']['output'];
  textPosition: StrapiHomePageTextPosition;
};

export type StrapiHomePageImageBannerComponent = StrapiContent & StrapiHomePageMetaInfoComponent & {
  __typename?: 'StrapiHomePageImageBannerComponent';
  buttons: Array<StrapiButton>;
  component: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: StrapiImage;
  teaserText: Scalars['String']['output'];
  textPosition: StrapiHomePageTextPosition;
};

export type StrapiHomePageMetaInfoComponent = {
  buttons: Array<StrapiButton>;
  component: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  teaserText: Scalars['String']['output'];
  textPosition: StrapiHomePageTextPosition;
};

export type StrapiHomePagePartnersGalleryComponent = {
  __typename?: 'StrapiHomePagePartnersGalleryComponent';
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images: Array<StrapiHomePagePartnersImages>;
  promoText: Scalars['String']['output'];
};

export type StrapiHomePagePartnersImages = {
  __typename?: 'StrapiHomePagePartnersImages';
  id: Scalars['ID']['output'];
  image?: Maybe<StrapiImage>;
  metTag: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type StrapiHomePageSlideBoxComponent = StrapiContent & {
  __typename?: 'StrapiHomePageSlideBoxComponent';
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  privateTitle: Scalars['String']['output'];
  slide: StrapiSlide;
};

export enum StrapiHomePageTextPosition {
  Left = 'Left',
  Right = 'Right'
}

export type StrapiImage = {
  __typename?: 'StrapiImage';
  alternativeText?: Maybe<Scalars['String']['output']>;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['Time']['output'];
  ext: Scalars['String']['output'];
  formats: Array<StrapiImageFormat>;
  hash: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  id: Scalars['ID']['output'];
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  overlay?: Maybe<StrapiImage>;
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  size: Scalars['Float']['output'];
  updatedAt: Scalars['Time']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type StrapiImageFormat = {
  __typename?: 'StrapiImageFormat';
  ext: Scalars['String']['output'];
  format: Scalars['String']['output'];
  hash: Scalars['String']['output'];
  height: Scalars['Int']['output'];
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  path?: Maybe<Scalars['String']['output']>;
  size: Scalars['Float']['output'];
  url: Scalars['String']['output'];
  width: Scalars['Int']['output'];
};

export type StrapiLayoutImage = StrapiContent & {
  __typename?: 'StrapiLayoutImage';
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<StrapiImage>;
  imageKey: Scalars['String']['output'];
};

export type StrapiLocalizedProductConfiguration = StrapiProductConfiguration & {
  __typename?: 'StrapiLocalizedProductConfiguration';
  available: Scalars['Boolean']['output'];
  city: Scalars['String']['output'];
  country: Scalars['String']['output'];
  countryCode: Scalars['String']['output'];
  duration: Scalars['Int']['output'];
  extensions: Array<StrapiOrderConfigurationExtension>;
  key: Scalars['String']['output'];
  orderUrl: Scalars['String']['output'];
  prices: Array<StrapiPrice>;
  slug: Scalars['String']['output'];
  units: Scalars['Int']['output'];
};

export type StrapiLocalizedSlug = {
  __typename?: 'StrapiLocalizedSlug';
  locale: Scalars['String']['output'];
  slug: Scalars['String']['output'];
};

export type StrapiLocationsMap = StrapiContent & {
  __typename?: 'StrapiLocationsMap';
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image: StrapiImage;
  layout: Scalars['String']['output'];
  subText: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type StrapiMediaGallery = StrapiContent & {
  __typename?: 'StrapiMediaGallery';
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  items: Array<StrapiMediaGalleryItem>;
  locale: Scalars['String']['output'];
  meta?: Maybe<StrapiHomePageMetaInfoComponent>;
  privateTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type StrapiMediaGalleryImageItem = StrapiMediaGalleryItem & {
  __typename?: 'StrapiMediaGalleryImageItem';
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  image?: Maybe<StrapiImage>;
};

export type StrapiMediaGalleryItem = {
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type StrapiMediaGalleryVideoItem = StrapiMediaGalleryItem & {
  __typename?: 'StrapiMediaGalleryVideoItem';
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  platform: Scalars['String']['output'];
  thumbnail?: Maybe<StrapiImage>;
  videoID: Scalars['String']['output'];
};

export type StrapiMinecraftModpack = {
  __typename?: 'StrapiMinecraftModpack';
  description: Scalars['String']['output'];
  icon: Scalars['String']['output'];
  key: Scalars['String']['output'];
  locale: Scalars['String']['output'];
  matchScore?: Maybe<Scalars['Float']['output']>;
  memory: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  orderUrl?: Maybe<Scalars['String']['output']>;
  rank: Scalars['Int']['output'];
  score: Scalars['Float']['output'];
  searchStrings: Array<Scalars['String']['output']>;
  tags: Array<StrapiMinecraftModpackTag>;
  unit: Scalars['String']['output'];
};

export type StrapiMinecraftModpackResult = PaginatorResponse & {
  __typename?: 'StrapiMinecraftModpackResult';
  entries: Array<StrapiMinecraftModpack>;
  totalEntries: Scalars['Int']['output'];
};

export type StrapiMinecraftModpackTag = {
  __typename?: 'StrapiMinecraftModpackTag';
  cssClasses: Scalars['String']['output'];
  rank: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  translationKey: StrapiTranslationKey;
};

export type StrapiOrderBadgeComponent = {
  __typename?: 'StrapiOrderBadgeComponent';
  endDate: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  maxCount: Scalars['Int']['output'];
  minCount: Scalars['Int']['output'];
};

export type StrapiOrderConfigurationContent = {
  __typename?: 'StrapiOrderConfigurationContent';
  backgroundImage: StrapiImage;
  duration: Scalars['Int']['output'];
  extensions: Array<StrapiOrderConfigurationExtension>;
  id: Scalars['ID']['output'];
  isFeatured: Scalars['Boolean']['output'];
  locations: Array<StrapiLocalizedProductConfiguration>;
  multiplier?: Maybe<Scalars['Float']['output']>;
  name: Scalars['String']['output'];
  unitType: Scalars['String']['output'];
  units: Scalars['Int']['output'];
};

export type StrapiOrderConfigurationExtension = {
  __typename?: 'StrapiOrderConfigurationExtension';
  chargebeeAddonId?: Maybe<Scalars['String']['output']>;
  extensionKey: Scalars['String']['output'];
  unitType?: Maybe<Scalars['String']['output']>;
  units: Scalars['Int']['output'];
};

export type StrapiOrderConfigurations = StrapiContent & {
  __typename?: 'StrapiOrderConfigurations';
  backgroundImage: StrapiImage;
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  orderConfigurations: Array<StrapiOrderConfigurationContent>;
  title: Scalars['String']['output'];
};

export type StrapiPage = {
  __typename?: 'StrapiPage';
  background?: Maybe<StrapiImage>;
  content: Array<StrapiContent>;
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  pageKey: Scalars['String']['output'];
  pageOrder?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['Time']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type StrapiPartner = StrapiContent & {
  __typename?: 'StrapiPartner';
  component: Scalars['String']['output'];
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profileImage: StrapiImage;
  publishedAt?: Maybe<Scalars['Time']['output']>;
  twitchHandle?: Maybe<Scalars['String']['output']>;
  twitterHandle?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
  website?: Maybe<Scalars['String']['output']>;
  youtubeHandle?: Maybe<Scalars['String']['output']>;
};

export type StrapiPaymentMethod = StrapiContent & {
  __typename?: 'StrapiPaymentMethod';
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  paymentMethods: Array<StrapiPaymentMethodContent>;
  title: Scalars['String']['output'];
};

export type StrapiPaymentMethodContent = {
  __typename?: 'StrapiPaymentMethodContent';
  createdAt: Scalars['Time']['output'];
  id: Scalars['ID']['output'];
  image: StrapiImage;
  publishedAt?: Maybe<Scalars['Time']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export enum StrapiPlatform {
  Pc = 'PC',
  Ps4 = 'PS4',
  XBox = 'XBox'
}

export type StrapiPrice = {
  __typename?: 'StrapiPrice';
  currency: Scalars['String']['output'];
  formatted: Scalars['String']['output'];
  value: Scalars['Int']['output'];
};

export type StrapiProduct = {
  __typename?: 'StrapiProduct';
  backgroundImage?: Maybe<StrapiImage>;
  chargebeePlanId?: Maybe<Scalars['String']['output']>;
  content: Array<StrapiContent>;
  coverImage: StrapiImage;
  createdAt: Scalars['Time']['output'];
  discountedPercentage: Scalars['Float']['output'];
  groups: Array<StrapiProductGroup>;
  headerCoverImage?: Maybe<StrapiImage>;
  id: Scalars['ID']['output'];
  isDiscountedGame: Scalars['Boolean']['output'];
  locale: Scalars['String']['output'];
  localizedSlugs: Array<StrapiLocalizedSlug>;
  matchScore?: Maybe<Scalars['Float']['output']>;
  metaDescription: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  name: Scalars['String']['output'];
  orderUrl?: Maybe<Scalars['String']['output']>;
  platform: StrapiPlatform;
  productKey?: Maybe<Scalars['String']['output']>;
  publishedAt: Scalars['Time']['output'];
  releaseAt?: Maybe<Scalars['Time']['output']>;
  searchStrings: Array<Scalars['String']['output']>;
  slug: Scalars['String']['output'];
  startConfiguration?: Maybe<StrapiProductStartConfiguration>;
  subHeadline: Scalars['String']['output'];
  title: Scalars['String']['output'];
  topBarFeature?: Maybe<StrapiTopBarFeature>;
  topCoverImage?: Maybe<StrapiImage>;
  type: StrapiProductType;
  updatedAt: Scalars['Time']['output'];
  wikiUrl: Scalars['String']['output'];
};

export type StrapiProductConfiguration = {
  duration: Scalars['Int']['output'];
  units: Scalars['Int']['output'];
};

export type StrapiProductContent = StrapiContent & {
  __typename?: 'StrapiProductContent';
  component: Scalars['String']['output'];
  content: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type StrapiProductCountdown = {
  __typename?: 'StrapiProductCountdown';
  countdown?: Maybe<StrapiCountdownComponent>;
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
};

export type StrapiProductFaq = StrapiContent & {
  __typename?: 'StrapiProductFaq';
  backgroundImage: StrapiImage;
  component: Scalars['String']['output'];
  frequentlyAskedQuestions: Array<StrapiFaqEntry>;
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
};

export type StrapiProductGallery = StrapiContent & {
  __typename?: 'StrapiProductGallery';
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images: Array<StrapiImage>;
  privateTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type StrapiProductGroup = {
  __typename?: 'StrapiProductGroup';
  createdAt: Scalars['Time']['output'];
  groupKey: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  publishedAt: Scalars['Time']['output'];
  rank: Scalars['Int']['output'];
  slug: Scalars['String']['output'];
  updatedAt: Scalars['Time']['output'];
};

export type StrapiProductStartConfiguration = StrapiProductConfiguration & {
  __typename?: 'StrapiProductStartConfiguration';
  duration: Scalars['Int']['output'];
  prices: Array<StrapiPrice>;
  units: Scalars['Int']['output'];
};

export enum StrapiProductType {
  Eps = 'Eps',
  Gameserver = 'Gameserver',
  Partner = 'Partner',
  Subscription = 'Subscription',
  Voiceserver = 'Voiceserver',
  Xbox = 'Xbox'
}

export type StrapiReviews = StrapiContent & {
  __typename?: 'StrapiReviews';
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type StrapiSlide = StrapiContent & {
  __typename?: 'StrapiSlide';
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  images: Array<StrapiImage>;
  parallaxImage?: Maybe<StrapiImage>;
  text: Scalars['String']['output'];
  textPosition: StrapiHomePageTextPosition;
  title: Scalars['String']['output'];
};

export type StrapiSustainabilityPage = {
  __typename?: 'StrapiSustainabilityPage';
  content: Array<StrapiContent>;
  createdAt: Scalars['Time']['output'];
  headerCoverImage: StrapiImage;
  headerText: Scalars['String']['output'];
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  locale: Scalars['String']['output'];
  localizedSlugs: Array<StrapiLocalizedSlug>;
  metaDescription: Scalars['String']['output'];
  metaTitle: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['Time']['output']>;
  updatedAt?: Maybe<Scalars['Time']['output']>;
};

export type StrapiTopBarFeature = {
  __typename?: 'StrapiTopBarFeature';
  icon?: Maybe<StrapiImage>;
  id: Scalars['Int']['output'];
  locale: Scalars['String']['output'];
  privateTitle: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type StrapiTranslationKey = {
  __typename?: 'StrapiTranslationKey';
  key: Scalars['String']['output'];
  namespace: Scalars['String']['output'];
};

export type StrapiTrustpilot = {
  __typename?: 'StrapiTrustpilot';
  backgroundImage?: Maybe<StrapiImage>;
  headline: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  promoText: Scalars['String']['output'];
};

export type StrapiVerticalMediaCompare = StrapiContent & {
  __typename?: 'StrapiVerticalMediaCompare';
  component: Scalars['String']['output'];
  headlineLeft: Scalars['String']['output'];
  headlineRight: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  imageLeft: StrapiImage;
  imageRight?: Maybe<StrapiImage>;
  locale: Scalars['String']['output'];
  tagLineLeft: Scalars['String']['output'];
  tagLineRight: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export type StrapiYouTubeVideo = StrapiContent & {
  __typename?: 'StrapiYouTubeVideo';
  component: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  videoUrl: Scalars['String']['output'];
};

export type TrustPilotScore = {
  __typename?: 'TrustPilotScore';
  stars: Scalars['Float']['output'];
  totalReviews: Scalars['Int']['output'];
  trustScore: Scalars['Float']['output'];
};

export type AllProductsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  currency: Scalars['String']['input'];
}>;


export type AllProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'StrapiProduct', name: string, platform: StrapiPlatform, releaseAt?: any | null, coverImage: { __typename?: 'StrapiImage', url: string, height: number, width: number, alternativeText?: string | null, overlay?: { __typename?: 'StrapiImage', url: string } | null }, groups: Array<{ __typename?: 'StrapiProductGroup', groupKey: string }> }> };

export type GetCheckoutProductQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  chargebeePlanId?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetCheckoutProductQuery = { __typename?: 'Query', products: Array<{ __typename?: 'StrapiProduct', productKey?: string | null, title: string, name: string, subHeadline: string, slug: string, coverImage: { __typename?: 'StrapiImage', url: string, width: number, height: number, alternativeText?: string | null }, backgroundImage?: { __typename?: 'StrapiImage', url: string, width: number, height: number, alternativeText?: string | null } | null, content: Array<{ __typename?: 'StrapiBanner' } | { __typename?: 'StrapiBenefit' } | { __typename?: 'StrapiButton' } | { __typename?: 'StrapiCustomComponent', id: string, component: string, customComponent: { __typename?: 'StrapiCustomComponentContent', componentKey: string, title: string, content?: string | null, displayLocation: DisplayLocation, buttons?: Array<{ __typename?: 'StrapiButton', id: string, text: string, link: string, type: string, newTab: boolean, image?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }> | null, layoutImages?: Array<{ __typename?: 'StrapiLayoutImage', id: string, imageKey: string, image?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }> | null, backgroundImage?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null } } | { __typename?: 'StrapiHomePageGalleryBannerComponent' } | { __typename?: 'StrapiHomePageImageBannerComponent' } | { __typename?: 'StrapiHomePageSlideBoxComponent' } | { __typename?: 'StrapiLayoutImage' } | { __typename?: 'StrapiLocationsMap' } | { __typename?: 'StrapiMediaGallery' } | { __typename?: 'StrapiOrderConfigurations' } | { __typename?: 'StrapiPartner' } | { __typename?: 'StrapiPaymentMethod' } | { __typename?: 'StrapiProductContent' } | { __typename?: 'StrapiProductFaq' } | { __typename?: 'StrapiProductGallery' } | { __typename?: 'StrapiReviews' } | { __typename?: 'StrapiSlide' } | { __typename?: 'StrapiVerticalMediaCompare' } | { __typename?: 'StrapiYouTubeVideo' }> }> };

export type GetContentPageQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetContentPageQuery = { __typename?: 'Query', product_top_bar: Array<{ __typename?: 'StrapiTopBarFeature', id: number, title: string, icon?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }>, product_countdown?: { __typename?: 'StrapiProductCountdown', id: string, countdown?: { __typename?: 'StrapiCountdownComponent', endDate: any, title: string } | null } | null, reviewScore?: { __typename?: 'TrustPilotScore', trustScore: number, totalReviews: number } | null, contentPages: Array<{ __typename?: 'StrapiContentPage', releaseAt?: any | null, updatedAt: any, locale: string, metaTitle: string, metaDescription: string, title: string, subHeadline: string, topBarFeature?: { __typename?: 'StrapiTopBarFeature', id: number, title: string, icon?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null } | null, coverImage: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, overlay?: { __typename?: 'StrapiImage', url: string } | null, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> }, headerCoverImage?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, overlay?: { __typename?: 'StrapiImage', url: string } | null, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null, content: Array<{ __typename?: 'StrapiBanner', title: string, text: string, promoText?: string | null, id: string, component: string, backgroundImage: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> }, buttons?: Array<{ __typename?: 'StrapiButton', id: string, component: string, text: string, link: string, type: string, newTab: boolean }> | null } | { __typename?: 'StrapiBenefit', title: string, id: string, component: string, benefits: Array<{ __typename?: 'StrapiBenefitContent', title: string, content: string, icon?: { __typename?: 'StrapiImage', url: string, width: number, height: number, alternativeText?: string | null } | null }> } | { __typename?: 'StrapiButton', id: string, component: string } | { __typename?: 'StrapiCustomComponent', id: string, component: string, customComponent: { __typename?: 'StrapiCustomComponentContent', componentKey: string, title: string, content?: string | null, buttons?: Array<{ __typename?: 'StrapiButton', id: string, text: string, link: string, type: string, newTab: boolean, image?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }> | null, layoutImages?: Array<{ __typename?: 'StrapiLayoutImage', id: string, imageKey: string, image?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }> | null, backgroundImage?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null } } | { __typename?: 'StrapiHomePageGalleryBannerComponent', id: string, component: string } | { __typename?: 'StrapiHomePageImageBannerComponent', id: string, component: string } | { __typename?: 'StrapiHomePageSlideBoxComponent', id: string, component: string } | { __typename?: 'StrapiLayoutImage', id: string, component: string } | { __typename?: 'StrapiLocationsMap', title: string, subText: string, layout: string, id: string, component: string, image: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } } | { __typename?: 'StrapiMediaGallery', title: string, id: string, component: string, items: Array<{ __typename?: 'StrapiMediaGalleryImageItem', component: string, image?: { __typename?: 'StrapiImage', id: string, alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null } | { __typename?: 'StrapiMediaGalleryVideoItem', id: string, platform: string, videoID: string, component: string, thumbnail?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }> } | { __typename?: 'StrapiOrderConfigurations', id: string, component: string } | { __typename?: 'StrapiPartner', id: string, component: string } | { __typename?: 'StrapiPaymentMethod', title: string, id: string, component: string, paymentMethods: Array<{ __typename?: 'StrapiPaymentMethodContent', title: string, image: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } }> } | { __typename?: 'StrapiProductContent', content: string, id: string, component: string } | { __typename?: 'StrapiProductFaq', title: string, id: string, component: string, backgroundImage: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> }, frequentlyAskedQuestions: Array<{ __typename?: 'StrapiFAQEntry', title: string, content: string, icon?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }> } | { __typename?: 'StrapiProductGallery', title: string, id: string, component: string, images: Array<{ __typename?: 'StrapiImage', id: string, alternativeText?: string | null, url: string, width: number, height: number, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> }> } | { __typename?: 'StrapiReviews', id: string, component: string } | { __typename?: 'StrapiSlide', id: string, component: string } | { __typename?: 'StrapiVerticalMediaCompare', id: string, component: string } | { __typename?: 'StrapiYouTubeVideo', title: string, videoUrl: string, id: string, component: string }>, localizedSlugs: Array<{ __typename?: 'StrapiLocalizedSlug', locale: string, slug: string }> }> };

export type GetDiscountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDiscountsQuery = { __typename?: 'Query', discounts: Array<{ __typename?: 'StrapiDiscount', id: string, discountKey: string, validFrom: any, validUntil: any, applyToAll: boolean, percent: number, couponCode?: string | null, products?: Array<{ __typename?: 'StrapiProduct', productKey?: string | null }> | null }> };

export type GetFooterPopularProductsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
}>;


export type GetFooterPopularProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'StrapiProduct', name: string, slug: string }> };

export type GetFooterTrustpilotScoreQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFooterTrustpilotScoreQuery = { __typename?: 'Query', reviewScore?: { __typename?: 'TrustPilotScore', trustScore: number, totalReviews: number } | null };

export type GetGamesQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  groups?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetGamesQuery = { __typename?: 'Query', products: Array<{ __typename?: 'StrapiProduct', id: string, type: StrapiProductType, releaseAt?: any | null, name: string, slug: string, locale: string, platform: StrapiPlatform, productKey?: string | null, isDiscountedGame: boolean, discountedPercentage: number, startConfiguration?: { __typename?: 'StrapiProductStartConfiguration', duration: number, prices: Array<{ __typename?: 'StrapiPrice', value: number, currency: string }> } | null, coverImage: { __typename?: 'StrapiImage', url: string, height: number, width: number, alternativeText?: string | null, overlay?: { __typename?: 'StrapiImage', url: string } | null } }> };

export type GetGameserverIndexQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  currency: Scalars['String']['input'];
}>;


export type GetGameserverIndexQuery = { __typename?: 'Query', reviewScore?: { __typename?: 'TrustPilotScore', trustScore: number, totalReviews: number } | null, gameserver?: { __typename?: 'StrapiGameserverIndex', updatedAt?: any | null, headline: string, metaTitle: string, metaDescription: string, description: string, trustpilot?: { __typename?: 'StrapiTrustpilot', headline: string, promoText: string, backgroundImage?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null } | null, countdown?: { __typename?: 'StrapiCountdownComponent', id: string, title: string, endDate: any } | null, benefits: { __typename?: 'StrapiBenefitList', title: string, benefits: Array<{ __typename?: 'StrapiBenefitContent', title: string, content: string, icon?: { __typename?: 'StrapiImage', url: string, width: number, height: number, alternativeText?: string | null } | null }> }, faq: { __typename?: 'StrapiFaqList', title: string, backgroundImage: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> }, frequentlyAskedQuestions: Array<{ __typename?: 'StrapiFAQEntry', title: string, content: string, icon?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }> }, topSeller?: { __typename?: 'StrapiProduct', type: StrapiProductType, name: string, releaseAt?: any | null, orderUrl?: string | null, locale: string, slug: string, productKey?: string | null, backgroundImage?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null } | null, localizedSlugs: Array<{ __typename?: 'StrapiLocalizedSlug', locale: string, slug: string }> } | null, products: Array<{ __typename?: 'StrapiProduct', id: string, type: StrapiProductType, name: string, releaseAt?: any | null, slug: string, locale: string, productKey?: string | null, isDiscountedGame: boolean, discountedPercentage: number, topCoverImage?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, overlay?: { __typename?: 'StrapiImage', url: string } | null, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null, startConfiguration?: { __typename?: 'StrapiProductStartConfiguration', duration: number, prices: Array<{ __typename?: 'StrapiPrice', value: number, currency: string }> } | null }> };

export type GetActiveEventQueryVariables = Exact<{ [key: string]: never; }>;


export type GetActiveEventQuery = { __typename?: 'Query', event?: { __typename?: 'StrapiEvent', reflink?: string | null, datetimeEnd: any } | null };

export type GetHomePageQueryVariables = Exact<{
  locale: Scalars['String']['input'];
}>;


export type GetHomePageQuery = { __typename?: 'Query', homePage?: { __typename?: 'StrapiHomePage', headline: string, metaTitle: string, metaDescription: string, blockbuster: { __typename?: 'StrapiBlockbuster', items: Array<{ __typename?: 'StrapiBlockbusterItemComponent', id: string, headline: string, title: string, text: string, backgroundImage: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> }, buttons: Array<{ __typename?: 'StrapiButton', text: string, link: string, type: string, newTab: boolean }> }> }, countdown?: { __typename?: 'StrapiCountdownComponent', id: string, title: string, endDate: any } | null, partnersGallery?: { __typename?: 'StrapiHomePagePartnersGalleryComponent', id: string, headline: string, promoText: string, images: Array<{ __typename?: 'StrapiHomePagePartnersImages', title: string, metTag: string, image?: { __typename?: 'StrapiImage', name: string, url: string } | null }> } | null, content: Array<{ __typename?: 'StrapiBanner', title: string, text: string, promoText?: string | null, id: string, component: string, backgroundImage: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> }, buttons?: Array<{ __typename?: 'StrapiButton', id: string, text: string, link: string, type: string, newTab: boolean }> | null } | { __typename?: 'StrapiBenefit', title: string, id: string, component: string, benefits: Array<{ __typename?: 'StrapiBenefitContent', privateTitle: string, content: string, title: string, isDefault: boolean, sort: number, icon?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }> } | { __typename?: 'StrapiButton', id: string, component: string } | { __typename?: 'StrapiCustomComponent', id: string, component: string, customComponent: { __typename?: 'StrapiCustomComponentContent', componentKey: string, title: string, content?: string | null, buttons?: Array<{ __typename?: 'StrapiButton', id: string, text: string, link: string, type: string, newTab: boolean, image?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }> | null, layoutImages?: Array<{ __typename?: 'StrapiLayoutImage', id: string, imageKey: string, image?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }> | null, backgroundImage?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null } } | { __typename?: 'StrapiHomePageGalleryBannerComponent', id: string, component: string } | { __typename?: 'StrapiHomePageImageBannerComponent', id: string, component: string } | { __typename?: 'StrapiHomePageSlideBoxComponent', privateTitle: string, id: string, component: string, slide: { __typename?: 'StrapiSlide', title: string, text: string, textPosition: StrapiHomePageTextPosition, parallaxImage?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null, images: Array<{ __typename?: 'StrapiImage', id: string, alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> }> } } | { __typename?: 'StrapiLayoutImage', id: string, component: string } | { __typename?: 'StrapiLocationsMap', id: string, component: string } | { __typename?: 'StrapiMediaGallery', title: string, id: string, component: string, items: Array<{ __typename?: 'StrapiMediaGalleryImageItem', component: string, image?: { __typename?: 'StrapiImage', id: string, alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null } | { __typename?: 'StrapiMediaGalleryVideoItem', id: string, platform: string, videoID: string, component: string, thumbnail?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }> } | { __typename?: 'StrapiOrderConfigurations', id: string, component: string } | { __typename?: 'StrapiPartner', id: string, component: string } | { __typename?: 'StrapiPaymentMethod', id: string, component: string } | { __typename?: 'StrapiProductContent', content: string, id: string, component: string } | { __typename?: 'StrapiProductFaq', id: string, component: string } | { __typename?: 'StrapiProductGallery', id: string, component: string } | { __typename?: 'StrapiReviews', id: string, component: string } | { __typename?: 'StrapiSlide', id: string, component: string } | { __typename?: 'StrapiVerticalMediaCompare', id: string, component: string } | { __typename?: 'StrapiYouTubeVideo', id: string, component: string }>, localizedSlugs: Array<{ __typename?: 'StrapiLocalizedSlug', locale: string, slug: string }> } | null };

export type GetHomePageProductsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  currency: Scalars['String']['input'];
  group?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;


export type GetHomePageProductsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'StrapiProduct', id: string, type: StrapiProductType, name: string, slug: string, locale: string, createdAt: any, productKey?: string | null, isDiscountedGame: boolean, discountedPercentage: number, topCoverImage?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, overlay?: { __typename?: 'StrapiImage', url: string } | null, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null, startConfiguration?: { __typename?: 'StrapiProductStartConfiguration', duration: number, prices: Array<{ __typename?: 'StrapiPrice', value: number, currency: string }> } | null }> };

export type GetMinecraftModpacksQueryVariables = Exact<{
  region: Scalars['String']['input'];
  locale: Scalars['String']['input'];
  search?: InputMaybe<Scalars['String']['input']>;
  currency?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetMinecraftModpacksQuery = { __typename?: 'Query', modpacks: { __typename?: 'StrapiMinecraftModpackResult', totalEntries: number, entries: Array<{ __typename?: 'StrapiMinecraftModpack', orderUrl?: string | null, key: string, name: string, memory: number, description: string, unit: string, icon: string, score: number, rank: number, locale: string, tags: Array<{ __typename?: 'StrapiMinecraftModpackTag', slug: string, translationKey: { __typename?: 'StrapiTranslationKey', namespace: string, key: string } }> }> } };

export type GetNavigationSlugsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  productKeys: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetNavigationSlugsQuery = { __typename?: 'Query', products: Array<{ __typename?: 'StrapiProduct', name: string, slug: string, productKey?: string | null }> };

export type GetNewsArticleDetailsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  type?: InputMaybe<StrapiArticleType>;
  slug: Scalars['String']['input'];
}>;


export type GetNewsArticleDetailsQuery = { __typename?: 'Query', articles: Array<{ __typename?: 'StrapiArticle', id: string, articleKey: string, title: string, type: StrapiArticleType, category: StrapiArticleCategory, slug: string, locale: string, metaTitle: string, metaDescription?: string | null, createdAt: any, updatedAt?: any | null, publishedAt?: any | null, teaserText: string, localizedSlugs: Array<{ __typename?: 'StrapiLocalizedSlug', locale: string, slug: string }>, teaserImage?: { __typename?: 'StrapiImage', url: string, width: number, height: number, formats: Array<{ __typename?: 'StrapiImageFormat', url: string, width: number, height: number }> } | null, thumbnailImage: { __typename?: 'StrapiImage', url: string, width: number, height: number, formats: Array<{ __typename?: 'StrapiImageFormat', url: string, width: number, height: number }> }, headerCoverImage: { __typename?: 'StrapiImage', url: string, width: number, height: number, overlay?: { __typename?: 'StrapiImage', url: string } | null, formats: Array<{ __typename?: 'StrapiImageFormat', url: string, width: number, height: number }> }, footerButtons: Array<{ __typename?: 'StrapiButton', id: string, link: string, newTab: boolean, text: string, type: string }>, content: Array<{ __typename?: 'StrapiBanner', id: string, component: string } | { __typename?: 'StrapiBenefit', id: string, component: string } | { __typename?: 'StrapiButton', id: string, type: string, link: string, newTab: boolean, text: string, component: string } | { __typename?: 'StrapiCustomComponent', id: string, component: string } | { __typename?: 'StrapiHomePageGalleryBannerComponent', id: string, component: string } | { __typename?: 'StrapiHomePageImageBannerComponent', id: string, component: string } | { __typename?: 'StrapiHomePageSlideBoxComponent', id: string, component: string } | { __typename?: 'StrapiLayoutImage', id: string, component: string } | { __typename?: 'StrapiLocationsMap', id: string, component: string } | { __typename?: 'StrapiMediaGallery', title: string, id: string, component: string, items: Array<{ __typename?: 'StrapiMediaGalleryImageItem', component: string, image?: { __typename?: 'StrapiImage', id: string, alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null } | { __typename?: 'StrapiMediaGalleryVideoItem', id: string, platform: string, videoID: string, component: string, thumbnail?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }> } | { __typename?: 'StrapiOrderConfigurations', id: string, component: string } | { __typename?: 'StrapiPartner', id: string, component: string } | { __typename?: 'StrapiPaymentMethod', id: string, component: string } | { __typename?: 'StrapiProductContent', id: string, content: string, component: string } | { __typename?: 'StrapiProductFaq', id: string, component: string } | { __typename?: 'StrapiProductGallery', id: string, component: string } | { __typename?: 'StrapiReviews', id: string, component: string } | { __typename?: 'StrapiSlide', id: string, component: string } | { __typename?: 'StrapiVerticalMediaCompare', id: string, component: string } | { __typename?: 'StrapiYouTubeVideo', id: string, component: string }> }> };

export type GetNewsArticlesQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  type?: InputMaybe<StrapiArticleType>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetNewsArticlesQuery = { __typename?: 'Query', articles: Array<{ __typename?: 'StrapiArticle', id: string, title: string, teaserText: string, type: StrapiArticleType, publishedAt?: any | null, locale: string, slug: string, category: StrapiArticleCategory, thumbnailImage: { __typename?: 'StrapiImage', width: number, height: number, url: string, overlay?: { __typename?: 'StrapiImage', url: string } | null }, headerCoverImage: { __typename?: 'StrapiImage', width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', url: string, width: number, height: number }>, overlay?: { __typename?: 'StrapiImage', url: string } | null }, teaserImage?: { __typename?: 'StrapiImage', width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', url: string, width: number, height: number }> } | null }> };

export type GetNewsIndexQueryVariables = Exact<{
  locale: Scalars['String']['input'];
}>;


export type GetNewsIndexQuery = { __typename?: 'Query', articleIndex?: { __typename?: 'StrapiArticlesIndex', id: string, headline: string, metaTitle: string, metaDescription: string, headerCoverImage?: { __typename?: 'StrapiImage', url: string, width: number, height: number, overlay?: { __typename?: 'StrapiImage', url: string } | null, formats: Array<{ __typename?: 'StrapiImageFormat', url: string, width: number, height: number }> } | null, localizedSlugs: Array<{ __typename?: 'StrapiLocalizedSlug', locale: string, slug: string }> } | null };

export type GetProductQueryVariables = Exact<{
  locale: Scalars['String']['input'];
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  currency: Scalars['String']['input'];
}>;


export type GetProductQuery = { __typename?: 'Query', product_top_bar: Array<{ __typename?: 'StrapiTopBarFeature', id: number, title: string, icon?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }>, product_countdown?: { __typename?: 'StrapiProductCountdown', id: string, countdown?: { __typename?: 'StrapiCountdownComponent', endDate: any, title: string } | null } | null, reviewScore?: { __typename?: 'TrustPilotScore', trustScore: number, totalReviews: number } | null, products: Array<{ __typename?: 'StrapiProduct', releaseAt?: any | null, updatedAt: any, type: StrapiProductType, locale: string, orderUrl?: string | null, metaTitle: string, metaDescription: string, title: string, subHeadline: string, productKey?: string | null, chargebeePlanId?: string | null, isDiscountedGame: boolean, discountedPercentage: number, startConfiguration?: { __typename?: 'StrapiProductStartConfiguration', units: number, duration: number, prices: Array<{ __typename?: 'StrapiPrice', value: number, currency: string, formatted: string }> } | null, topBarFeature?: { __typename?: 'StrapiTopBarFeature', id: number, title: string, icon?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null } | null, coverImage: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, overlay?: { __typename?: 'StrapiImage', url: string } | null, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> }, headerCoverImage?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, overlay?: { __typename?: 'StrapiImage', url: string } | null, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null, content: Array<{ __typename?: 'StrapiBanner', title: string, text: string, promoText?: string | null, id: string, component: string, backgroundImage: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> }, buttons?: Array<{ __typename?: 'StrapiButton', id: string, component: string, text: string, link: string, type: string, newTab: boolean }> | null } | { __typename?: 'StrapiBenefit', title: string, id: string, component: string, benefits: Array<{ __typename?: 'StrapiBenefitContent', title: string, content: string, icon?: { __typename?: 'StrapiImage', url: string, width: number, height: number, alternativeText?: string | null } | null }> } | { __typename?: 'StrapiButton', id: string, component: string } | { __typename?: 'StrapiCustomComponent', id: string, component: string, customComponent: { __typename?: 'StrapiCustomComponentContent', componentKey: string, title: string, content?: string | null, displayLocation: DisplayLocation, buttons?: Array<{ __typename?: 'StrapiButton', id: string, text: string, link: string, type: string, newTab: boolean, image?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }> | null, layoutImages?: Array<{ __typename?: 'StrapiLayoutImage', id: string, imageKey: string, image?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }> | null, backgroundImage?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null } } | { __typename?: 'StrapiHomePageGalleryBannerComponent', id: string, component: string } | { __typename?: 'StrapiHomePageImageBannerComponent', id: string, component: string } | { __typename?: 'StrapiHomePageSlideBoxComponent', id: string, component: string } | { __typename?: 'StrapiLayoutImage', id: string, component: string } | { __typename?: 'StrapiLocationsMap', title: string, subText: string, layout: string, id: string, component: string, image: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } } | { __typename?: 'StrapiMediaGallery', title: string, id: string, component: string, items: Array<{ __typename?: 'StrapiMediaGalleryImageItem', component: string, image?: { __typename?: 'StrapiImage', id: string, alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null } | { __typename?: 'StrapiMediaGalleryVideoItem', id: string, platform: string, videoID: string, component: string, thumbnail?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }> } | { __typename?: 'StrapiOrderConfigurations', title: string, id: string, component: string, backgroundImage: { __typename?: 'StrapiImage', url: string, width: number, height: number, alternativeText?: string | null }, orderConfigurations: Array<{ __typename?: 'StrapiOrderConfigurationContent', id: string, isFeatured: boolean, duration: number, units: number, unitType: string, locations: Array<{ __typename?: 'StrapiLocalizedProductConfiguration', available: boolean, key: string, orderUrl: string, slug: string, country: string, countryCode: string, city: string, prices: Array<{ __typename?: 'StrapiPrice', value: number, currency: string, formatted: string }> }>, extensions: Array<{ __typename?: 'StrapiOrderConfigurationExtension', extensionKey: string, units: number, unitType?: string | null, chargebeeAddonId?: string | null }>, backgroundImage: { __typename?: 'StrapiImage', url: string, alternativeText?: string | null, height: number, width: number } }> } | { __typename?: 'StrapiPartner', id: string, component: string } | { __typename?: 'StrapiPaymentMethod', title: string, id: string, component: string, paymentMethods: Array<{ __typename?: 'StrapiPaymentMethodContent', title: string, image: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } }> } | { __typename?: 'StrapiProductContent', content: string, id: string, component: string } | { __typename?: 'StrapiProductFaq', title: string, id: string, component: string, backgroundImage: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> }, frequentlyAskedQuestions: Array<{ __typename?: 'StrapiFAQEntry', title: string, content: string, icon?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }> } | { __typename?: 'StrapiProductGallery', title: string, id: string, component: string, images: Array<{ __typename?: 'StrapiImage', id: string, alternativeText?: string | null, url: string, width: number, height: number, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> }> } | { __typename?: 'StrapiReviews', id: string, component: string } | { __typename?: 'StrapiSlide', id: string, component: string } | { __typename?: 'StrapiVerticalMediaCompare', id: string, component: string } | { __typename?: 'StrapiYouTubeVideo', title: string, videoUrl: string, id: string, component: string }>, localizedSlugs: Array<{ __typename?: 'StrapiLocalizedSlug', locale: string, slug: string }> }> };

export type GetProductGroupsQueryVariables = Exact<{
  locale: Scalars['String']['input'];
}>;


export type GetProductGroupsQuery = { __typename?: 'Query', productGroups: Array<{ __typename?: 'StrapiProductGroup', groupKey: string, slug: string, rank: number }> };

export type GetSustainabilityPageQueryVariables = Exact<{
  locale: Scalars['String']['input'];
}>;


export type GetSustainabilityPageQuery = { __typename?: 'Query', sustainabilityPage?: { __typename?: 'StrapiSustainabilityPage', id: string, headline: string, metaTitle: string, metaDescription: string, headerText: string, localizedSlugs: Array<{ __typename?: 'StrapiLocalizedSlug', locale: string, slug: string }>, headerCoverImage: { __typename?: 'StrapiImage', url: string, width: number, height: number, overlay?: { __typename?: 'StrapiImage', url: string } | null, formats: Array<{ __typename?: 'StrapiImageFormat', url: string, width: number, height: number }> }, content: Array<{ __typename?: 'StrapiBanner', title: string, text: string, promoText?: string | null, component: string, id: string, backgroundImage: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> }, buttons?: Array<{ __typename?: 'StrapiButton', id: string, text: string, link: string, type: string, newTab: boolean }> | null } | { __typename?: 'StrapiBenefit', component: string, id: string } | { __typename?: 'StrapiButton', component: string, id: string } | { __typename?: 'StrapiCustomComponent', component: string, id: string } | { __typename?: 'StrapiHomePageGalleryBannerComponent', component: string, id: string } | { __typename?: 'StrapiHomePageImageBannerComponent', component: string, id: string } | { __typename?: 'StrapiHomePageSlideBoxComponent', privateTitle: string, component: string, id: string, slide: { __typename?: 'StrapiSlide', title: string, text: string, textPosition: StrapiHomePageTextPosition, parallaxImage?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null, images: Array<{ __typename?: 'StrapiImage', id: string, alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> }> } } | { __typename?: 'StrapiLayoutImage', component: string, id: string } | { __typename?: 'StrapiLocationsMap', title: string, subText: string, layout: string, component: string, id: string, image: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } } | { __typename?: 'StrapiMediaGallery', component: string, id: string } | { __typename?: 'StrapiOrderConfigurations', component: string, id: string } | { __typename?: 'StrapiPartner', component: string, id: string } | { __typename?: 'StrapiPaymentMethod', component: string, id: string } | { __typename?: 'StrapiProductContent', component: string, id: string } | { __typename?: 'StrapiProductFaq', title: string, component: string, id: string, backgroundImage: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> }, frequentlyAskedQuestions: Array<{ __typename?: 'StrapiFAQEntry', title: string, content: string, icon?: { __typename?: 'StrapiImage', alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null }> } | { __typename?: 'StrapiProductGallery', component: string, id: string } | { __typename?: 'StrapiReviews', component: string, id: string } | { __typename?: 'StrapiSlide', component: string, id: string } | { __typename?: 'StrapiVerticalMediaCompare', title: string, headlineLeft: string, headlineRight: string, tagLineLeft: string, tagLineRight: string, component: string, id: string, imageLeft: { __typename?: 'StrapiImage', id: string, alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> }, imageRight?: { __typename?: 'StrapiImage', id: string, alternativeText?: string | null, width: number, height: number, url: string, formats: Array<{ __typename?: 'StrapiImageFormat', width: number, height: number, format: string, url: string }> } | null } | { __typename?: 'StrapiYouTubeVideo', component: string, id: string }> } | null };


export const AllProducts = gql`
    query AllProducts($locale: String!, $currency: String!) {
  products(locale: $locale, currency: $currency) {
    name
    platform
    releaseAt
    coverImage {
      url
      height
      width
      alternativeText
      overlay {
        url
      }
    }
    groups {
      groupKey
    }
  }
}
    `;
export const GetCheckoutProduct = gql`
    query GetCheckoutProduct($locale: String!, $currency: String!, $chargebeePlanId: [String]) {
  products(
    locale: $locale
    currency: $currency
    chargebeePlanId: $chargebeePlanId
    displayLocation: CHECKOUT
  ) {
    productKey
    title
    name
    subHeadline
    slug
    coverImage {
      url
      width
      height
      alternativeText
    }
    backgroundImage {
      url
      width
      height
      alternativeText
    }
    content {
      ... on StrapiCustomComponent {
        id
        component
        customComponent {
          componentKey
          title
          content
          displayLocation
          buttons {
            id
            text
            link
            type
            newTab
            image {
              alternativeText
              width
              height
              url
              formats {
                width
                height
                format
                url
              }
            }
          }
          layoutImages {
            id
            imageKey
            image {
              alternativeText
              width
              height
              url
              formats {
                width
                height
                format
                url
              }
            }
          }
          backgroundImage {
            alternativeText
            width
            height
            url
            formats {
              width
              height
              format
              url
            }
          }
        }
      }
    }
  }
}
    `;
export const GetContentPage = gql`
    query GetContentPage($locale: String!, $slugs: [String]) {
  product_top_bar(locale: $locale) {
    id
    title
    icon {
      alternativeText
      width
      height
      url
      formats {
        width
        height
        format
        url
      }
    }
  }
  product_countdown(locale: $locale) {
    id
    countdown {
      endDate
      title
    }
  }
  reviewScore {
    trustScore
    totalReviews
  }
  contentPages(slug_match: $slugs, locale: $locale) {
    releaseAt
    updatedAt
    locale
    metaTitle
    metaDescription
    title
    subHeadline
    topBarFeature {
      id
      title
      icon {
        alternativeText
        width
        height
        url
        formats {
          width
          height
          format
          url
        }
      }
    }
    coverImage {
      alternativeText
      width
      height
      url
      overlay {
        url
      }
      formats {
        width
        height
        format
        url
      }
    }
    headerCoverImage {
      alternativeText
      width
      height
      url
      overlay {
        url
      }
      formats {
        width
        height
        format
        url
      }
    }
    content {
      id
      component
      ... on StrapiYouTubeVideo {
        title
        videoUrl
      }
      ... on StrapiBenefit {
        title
        benefits {
          title
          content
          icon {
            url
            width
            height
            alternativeText
          }
        }
      }
      ... on StrapiLocationsMap {
        title
        subText
        layout
        image {
          alternativeText
          width
          height
          url
          formats {
            width
            height
            format
            url
          }
        }
      }
      ... on StrapiBanner {
        title
        text
        backgroundImage {
          alternativeText
          width
          height
          url
          formats {
            width
            height
            format
            url
          }
        }
        buttons {
          id
          component
          text
          link
          type
          newTab
        }
        promoText
      }
      ... on StrapiCustomComponent {
        customComponent {
          componentKey
          title
          content
          buttons {
            id
            text
            link
            type
            newTab
            image {
              alternativeText
              width
              height
              url
              formats {
                width
                height
                format
                url
              }
            }
          }
          layoutImages {
            id
            imageKey
            image {
              alternativeText
              width
              height
              url
              formats {
                width
                height
                format
                url
              }
            }
          }
          backgroundImage {
            alternativeText
            width
            height
            url
            formats {
              width
              height
              format
              url
            }
          }
        }
      }
      ... on StrapiPaymentMethod {
        title
        paymentMethods {
          title
          image {
            alternativeText
            width
            height
            url
            formats {
              width
              height
              format
              url
            }
          }
        }
      }
      ... on StrapiProductContent {
        content
      }
      ... on StrapiMediaGallery {
        title
        items {
          component
          ... on StrapiMediaGalleryVideoItem {
            id
            platform
            videoID
            thumbnail {
              alternativeText
              width
              height
              url
              formats {
                width
                height
                format
                url
              }
            }
          }
          ... on StrapiMediaGalleryImageItem {
            image {
              id
              alternativeText
              width
              height
              url
              formats {
                width
                height
                format
                url
              }
            }
          }
        }
      }
      ... on StrapiProductFaq {
        title
        backgroundImage {
          alternativeText
          width
          height
          url
          formats {
            width
            height
            format
            url
          }
        }
        frequentlyAskedQuestions {
          title
          content
          icon {
            alternativeText
            width
            height
            url
            formats {
              width
              height
              format
              url
            }
          }
        }
      }
      ... on StrapiProductGallery {
        title
        images {
          id
          alternativeText
          url
          width
          height
          formats {
            width
            height
            format
            url
          }
        }
      }
    }
    localizedSlugs {
      locale
      slug
    }
  }
}
    `;
export const GetDiscounts = gql`
    query GetDiscounts {
  discounts {
    id
    discountKey
    validFrom
    validUntil
    applyToAll
    percent
    couponCode
    products {
      productKey
    }
  }
}
    `;
export const GetFooterPopularProducts = gql`
    query GetFooterPopularProducts($locale: String!) {
  products(group: ["Popular"], slug_match: [".*"], locale: $locale) {
    name
    slug
  }
}
    `;
export const GetFooterTrustpilotScore = gql`
    query GetFooterTrustpilotScore {
  reviewScore {
    trustScore
    totalReviews
  }
}
    `;
export const GetGames = gql`
    query GetGames($locale: String!, $currency: String!, $search: String, $groups: [String]) {
  products(
    locale: $locale
    currency: $currency
    product_type: [Gameserver, Xbox]
    search: $search
    group: $groups
  ) {
    id
    type
    releaseAt
    name
    slug
    locale
    platform
    productKey
    isDiscountedGame
    discountedPercentage
    startConfiguration {
      duration
      prices {
        value
        currency
      }
    }
    coverImage {
      url
      height
      width
      alternativeText
      overlay {
        url
      }
    }
  }
}
    `;
export const GetGameserverIndex = gql`
    query GetGameserverIndex($locale: String!, $currency: String!) {
  reviewScore {
    trustScore
    totalReviews
  }
  gameserver(locale: $locale, currency: $currency) {
    updatedAt
    headline
    metaTitle
    metaDescription
    description
    trustpilot {
      headline
      promoText
      backgroundImage {
        alternativeText
        width
        height
        url
        formats {
          width
          height
          format
          url
        }
      }
    }
    countdown {
      id
      title
      endDate
    }
    benefits {
      title
      benefits {
        title
        content
        icon {
          url
          width
          height
          alternativeText
        }
      }
    }
    faq {
      title
      backgroundImage {
        alternativeText
        width
        height
        url
        formats {
          width
          height
          format
          url
        }
      }
      frequentlyAskedQuestions {
        title
        content
        icon {
          alternativeText
          width
          height
          url
          formats {
            width
            height
            format
            url
          }
        }
      }
    }
    topSeller {
      type
      name
      releaseAt
      orderUrl
      locale
      slug
      productKey
      backgroundImage {
        alternativeText
        width
        height
        url
        formats {
          width
          height
          format
          url
        }
      }
    }
    localizedSlugs {
      locale
      slug
    }
  }
  products(locale: $locale, currency: $currency, group: "Popular") {
    id
    type
    name
    releaseAt
    slug
    locale
    productKey
    isDiscountedGame
    discountedPercentage
    topCoverImage {
      alternativeText
      width
      height
      url
      overlay {
        url
      }
      formats {
        width
        height
        format
        url
      }
    }
    startConfiguration {
      duration
      prices {
        value
        currency
      }
    }
  }
}
    `;
export const GetActiveEvent = gql`
    query GetActiveEvent {
  event {
    reflink
    datetimeEnd
  }
}
    `;
export const GetHomePage = gql`
    query GetHomePage($locale: String!) {
  homePage(locale: $locale) {
    headline
    metaTitle
    metaDescription
    blockbuster {
      items {
        ... on StrapiBlockbusterItemComponent {
          id
          headline
          title
          text
          backgroundImage {
            alternativeText
            width
            height
            url
            formats {
              width
              height
              format
              url
            }
          }
          buttons {
            text
            link
            type
            newTab
          }
        }
      }
    }
    countdown {
      id
      title
      endDate
    }
    partnersGallery {
      id
      headline
      promoText
      images {
        title
        metTag
        image {
          name
          url
        }
      }
    }
    content {
      id
      component
      ... on StrapiHomePageSlideBoxComponent {
        privateTitle
        slide {
          title
          text
          textPosition
          parallaxImage {
            alternativeText
            width
            height
            url
            formats {
              width
              height
              format
              url
            }
          }
          images {
            id
            alternativeText
            width
            height
            url
            formats {
              width
              height
              format
              url
            }
          }
        }
      }
      ... on StrapiBanner {
        title
        text
        backgroundImage {
          alternativeText
          width
          height
          url
          formats {
            width
            height
            format
            url
          }
        }
        buttons {
          id
          text
          link
          type
          newTab
        }
        promoText
      }
      ... on StrapiMediaGallery {
        title
        items {
          component
          ... on StrapiMediaGalleryVideoItem {
            id
            platform
            videoID
            thumbnail {
              alternativeText
              width
              height
              url
              formats {
                width
                height
                format
                url
              }
            }
          }
          ... on StrapiMediaGalleryImageItem {
            image {
              id
              alternativeText
              width
              height
              url
              formats {
                width
                height
                format
                url
              }
            }
          }
        }
      }
      ... on StrapiBenefit {
        title
        benefits {
          privateTitle
          icon {
            alternativeText
            width
            height
            url
            formats {
              width
              height
              format
              url
            }
          }
          content
          title
          isDefault
          sort
        }
      }
      ... on StrapiProductContent {
        content
      }
      ... on StrapiCustomComponent {
        customComponent {
          componentKey
          title
          content
          buttons {
            id
            text
            link
            type
            newTab
            image {
              alternativeText
              width
              height
              url
              formats {
                width
                height
                format
                url
              }
            }
          }
          layoutImages {
            id
            imageKey
            image {
              alternativeText
              width
              height
              url
              formats {
                width
                height
                format
                url
              }
            }
          }
          backgroundImage {
            alternativeText
            width
            height
            url
            formats {
              width
              height
              format
              url
            }
          }
        }
      }
    }
    localizedSlugs {
      locale
      slug
    }
  }
}
    `;
export const GetHomePageProducts = gql`
    query GetHomePageProducts($locale: String!, $currency: String!, $group: [String]) {
  products(locale: $locale, currency: $currency, group: $group) {
    id
    type
    name
    slug
    locale
    createdAt
    productKey
    isDiscountedGame
    discountedPercentage
    topCoverImage {
      alternativeText
      width
      height
      url
      overlay {
        url
      }
      formats {
        width
        height
        format
        url
      }
    }
    startConfiguration {
      duration
      prices {
        value
        currency
      }
    }
  }
}
    `;
export const GetMinecraftModpacks = gql`
    query GetMinecraftModpacks($region: String!, $locale: String!, $search: String, $currency: String, $limit: Int, $offset: Int) {
  modpacks(
    region: $region
    locale: $locale
    search: $search
    limit: $limit
    currency: $currency
    offset: $offset
  ) {
    entries {
      orderUrl
      key
      name
      memory
      description
      unit
      icon
      score
      rank
      tags {
        slug
        translationKey {
          namespace
          key
        }
      }
      locale
    }
    totalEntries
  }
}
    `;
export const GetNavigationSlugs = gql`
    query GetNavigationSlugs($locale: String!, $productKeys: [String!]!) {
  products(locale: $locale, productKey: $productKeys) {
    name
    slug
    productKey
  }
}
    `;
export const GetNewsArticleDetails = gql`
    query GetNewsArticleDetails($locale: String!, $type: StrapiArticleType, $slug: String!) {
  articles(locale: $locale, type: $type, limit: 1, slug: [$slug]) {
    id
    articleKey
    title
    type
    category
    slug
    locale
    metaTitle
    metaDescription
    createdAt
    updatedAt
    publishedAt
    localizedSlugs {
      locale
      slug
    }
    teaserText
    teaserImage {
      url
      formats {
        url
        width
        height
      }
      width
      height
    }
    thumbnailImage {
      url
      formats {
        url
        width
        height
      }
      width
      height
    }
    headerCoverImage {
      url
      overlay {
        url
      }
      formats {
        url
        width
        height
      }
      width
      height
    }
    footerButtons {
      id
      link
      newTab
      text
      type
    }
    content {
      id
      component
      ... on StrapiButton {
        id
        type
        link
        newTab
        text
      }
      ... on StrapiProductContent {
        id
        content
      }
      ... on StrapiMediaGallery {
        title
        items {
          component
          ... on StrapiMediaGalleryVideoItem {
            id
            platform
            videoID
            thumbnail {
              alternativeText
              width
              height
              url
              formats {
                width
                height
                format
                url
              }
            }
          }
          ... on StrapiMediaGalleryImageItem {
            image {
              id
              alternativeText
              width
              height
              url
              formats {
                width
                height
                format
                url
              }
            }
          }
        }
      }
    }
  }
}
    `;
export const GetNewsArticles = gql`
    query GetNewsArticles($locale: String!, $type: StrapiArticleType, $limit: Int, $offset: Int) {
  articles(locale: $locale, limit: $limit, offset: $offset, type: $type) {
    id
    title
    teaserText
    type
    publishedAt
    locale
    slug
    category
    thumbnailImage {
      width
      height
      url
      overlay {
        url
      }
    }
    headerCoverImage {
      width
      height
      url
      formats {
        url
        width
        height
      }
      overlay {
        url
      }
    }
    teaserImage {
      width
      height
      url
      formats {
        url
        width
        height
      }
    }
  }
}
    `;
export const GetNewsIndex = gql`
    query GetNewsIndex($locale: String!) {
  articleIndex(locale: $locale) {
    id
    headline
    metaTitle
    metaDescription
    headerCoverImage {
      url
      overlay {
        url
      }
      formats {
        url
        width
        height
      }
      width
      height
    }
    localizedSlugs {
      locale
      slug
    }
  }
}
    `;
export const GetProduct = gql`
    query GetProduct($locale: String!, $slugs: [String], $currency: String!) {
  product_top_bar(locale: $locale) {
    id
    title
    icon {
      alternativeText
      width
      height
      url
      formats {
        width
        height
        format
        url
      }
    }
  }
  product_countdown(locale: $locale) {
    id
    countdown {
      endDate
      title
    }
  }
  reviewScore {
    trustScore
    totalReviews
  }
  products(
    slug_match: $slugs
    locale: $locale
    currency: $currency
    displayLocation: LANDING_PAGE
  ) {
    releaseAt
    updatedAt
    type
    locale
    orderUrl
    metaTitle
    metaDescription
    startConfiguration {
      units
      duration
      prices {
        value
        currency
        formatted
      }
    }
    title
    subHeadline
    productKey
    chargebeePlanId
    isDiscountedGame
    discountedPercentage
    topBarFeature {
      id
      title
      icon {
        alternativeText
        width
        height
        url
        formats {
          width
          height
          format
          url
        }
      }
    }
    coverImage {
      alternativeText
      width
      height
      url
      overlay {
        url
      }
      formats {
        width
        height
        format
        url
      }
    }
    headerCoverImage {
      alternativeText
      width
      height
      url
      overlay {
        url
      }
      formats {
        width
        height
        format
        url
      }
    }
    content {
      id
      component
      ... on StrapiYouTubeVideo {
        title
        videoUrl
      }
      ... on StrapiOrderConfigurations {
        title
        backgroundImage {
          url
          width
          height
          alternativeText
        }
        orderConfigurations {
          id
          isFeatured
          duration
          units
          unitType
          locations {
            available
            key
            prices {
              value
              currency
              formatted
            }
            orderUrl
            slug
            country
            countryCode
            city
          }
          extensions {
            extensionKey
            units
            unitType
            chargebeeAddonId
          }
          backgroundImage {
            url
            alternativeText
            height
            width
          }
        }
      }
      ... on StrapiBenefit {
        title
        benefits {
          title
          content
          icon {
            url
            width
            height
            alternativeText
          }
        }
      }
      ... on StrapiLocationsMap {
        title
        subText
        layout
        image {
          alternativeText
          width
          height
          url
          formats {
            width
            height
            format
            url
          }
        }
      }
      ... on StrapiBanner {
        title
        text
        backgroundImage {
          alternativeText
          width
          height
          url
          formats {
            width
            height
            format
            url
          }
        }
        buttons {
          id
          component
          text
          link
          type
          newTab
        }
        promoText
      }
      ... on StrapiCustomComponent {
        customComponent {
          componentKey
          title
          content
          displayLocation
          buttons {
            id
            text
            link
            type
            newTab
            image {
              alternativeText
              width
              height
              url
              formats {
                width
                height
                format
                url
              }
            }
          }
          layoutImages {
            id
            imageKey
            image {
              alternativeText
              width
              height
              url
              formats {
                width
                height
                format
                url
              }
            }
          }
          backgroundImage {
            alternativeText
            width
            height
            url
            formats {
              width
              height
              format
              url
            }
          }
        }
      }
      ... on StrapiPaymentMethod {
        title
        paymentMethods {
          title
          image {
            alternativeText
            width
            height
            url
            formats {
              width
              height
              format
              url
            }
          }
        }
      }
      ... on StrapiProductContent {
        content
      }
      ... on StrapiMediaGallery {
        title
        items {
          component
          ... on StrapiMediaGalleryVideoItem {
            id
            platform
            videoID
            thumbnail {
              alternativeText
              width
              height
              url
              formats {
                width
                height
                format
                url
              }
            }
          }
          ... on StrapiMediaGalleryImageItem {
            image {
              id
              alternativeText
              width
              height
              url
              formats {
                width
                height
                format
                url
              }
            }
          }
        }
      }
      ... on StrapiProductFaq {
        title
        backgroundImage {
          alternativeText
          width
          height
          url
          formats {
            width
            height
            format
            url
          }
        }
        frequentlyAskedQuestions {
          title
          content
          icon {
            alternativeText
            width
            height
            url
            formats {
              width
              height
              format
              url
            }
          }
        }
      }
      ... on StrapiProductGallery {
        title
        images {
          id
          alternativeText
          url
          width
          height
          formats {
            width
            height
            format
            url
          }
        }
      }
    }
    localizedSlugs {
      locale
      slug
    }
  }
}
    `;
export const GetProductGroups = gql`
    query GetProductGroups($locale: String!) {
  productGroups(locale: $locale) {
    groupKey
    slug
    rank
  }
}
    `;
export const GetSustainabilityPage = gql`
    query GetSustainabilityPage($locale: String!) {
  sustainabilityPage(locale: $locale) {
    id
    headline
    metaTitle
    metaDescription
    headerText
    localizedSlugs {
      locale
      slug
    }
    headerCoverImage {
      url
      overlay {
        url
      }
      formats {
        url
        width
        height
      }
      width
      height
    }
    content {
      component
      id
      ... on StrapiLocationsMap {
        title
        subText
        layout
        image {
          alternativeText
          width
          height
          url
          formats {
            width
            height
            format
            url
          }
        }
      }
      ... on StrapiHomePageSlideBoxComponent {
        privateTitle
        slide {
          title
          text
          textPosition
          parallaxImage {
            alternativeText
            width
            height
            url
            formats {
              width
              height
              format
              url
            }
          }
          images {
            id
            alternativeText
            width
            height
            url
            formats {
              width
              height
              format
              url
            }
          }
        }
      }
      ... on StrapiBanner {
        title
        text
        backgroundImage {
          alternativeText
          width
          height
          url
          formats {
            width
            height
            format
            url
          }
        }
        buttons {
          id
          text
          link
          type
          newTab
        }
        promoText
      }
      ... on StrapiProductFaq {
        title
        backgroundImage {
          alternativeText
          width
          height
          url
          formats {
            width
            height
            format
            url
          }
        }
        frequentlyAskedQuestions {
          title
          content
          icon {
            alternativeText
            width
            height
            url
            formats {
              width
              height
              format
              url
            }
          }
        }
      }
      ... on StrapiVerticalMediaCompare {
        title
        headlineLeft
        headlineRight
        tagLineLeft
        tagLineRight
        imageLeft {
          id
          alternativeText
          width
          height
          url
          formats {
            width
            height
            format
            url
          }
        }
        imageRight {
          id
          alternativeText
          width
          height
          url
          formats {
            width
            height
            format
            url
          }
        }
      }
    }
  }
}
    `;